import React from "react";

export default function Section1() {
    return (
		<g id="kinderen">
			<path style={{fill:"#7BC143"}} d="M695.72,1110.53h-65.09c-28.31,0-51.25-26.53-51.25-59.26s22.95-59.26,51.25-59.26h-3.76   c18.05,0,32.68-16.92,32.68-37.79s-14.63-37.79-32.68-37.79H349.34c-18.05,0-32.68,16.92-32.68,37.79s14.63,37.79,32.68,37.79   H210.3c-28.3,0-51.25,26.53-51.25,59.26c0,32.73,22.95,59.26,51.25,59.26h78.38"/>
	        <path style={{fill:"#7BC143"}} d="M410.88,978.03h58.94c25.63,0,46.41,24.73,46.41,55.24c0,30.51-20.78,55.24-46.41,55.24h3.4   c-16.34,0-29.59,15.77-29.59,35.22s13.25,35.22,29.59,35.22l251.28,0c16.34,0,29.59-15.77,29.59-35.22   c0-19.45-13.25-35.22-29.59-35.22h125.9c25.63,0,46.4-24.73,46.4-55.23c0-30.51-20.78-55.24-46.4-55.24h-70.97"/>
		</g>
    )
}